<template>
  <div>
    <div class="header">
      <h1>{{ detail.name }}</h1>
      <div class="header-content">
        <div class="left">
          <div class="item-box" style="margin-bottom: 30px">
            <div class="item">已使用：{{ detail.usedCount || 0 }}</div>
            <div class="item">剩余可用：{{ detail.isLimitCount ? detail.maxCount - detail.usedCount : '不限制' }}</div>
            <div class="item">截止使用日期：{{ detail.isLimitUsageDate ? moment(detail.uneffectiveDate).format('YYYY/MM/DD') : '永久使用' }}</div>
          </div>
          <div class="item-box" style="margin-bottom: 30px">
            <div class="item">资源个数：{{ detail.count }}个</div>
            <div class="item">大小：{{ detail.size || '--' }}</div>
            <div class="item">下载次数：{{ detail.totalDownloads }}</div>
          </div>
          <div class="item-box" style="margin-bottom: 30px">
            <div class="item">简介：{{ detail.description || '--' }}</div>
            <div class="item">备注：{{ detail.remark || '--' }}</div>
            <div class="item">查看次数：{{ detail.totalViews }}</div>
          </div>
        </div>
      </div>
    </div>
    <a-card class="table">
      <a-form :labelCol="{ span: 5 }" :wrapperCol="{ span: 16 }">
        <a-row>
          <a-col :span="6">
            <a-form-item label="资源标题">
              <a-input v-model.trim="searchForm.name" v-trim placeholder="请输入资源标题" :maxLength="20" allowClear />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="类型">
              <a-select v-model="searchForm.fileType" placeholder="请选择类型" allowClear>
                <a-select-option value="1">文档</a-select-option>
                <!-- <a-select-option value="2">PPT</a-select-option> -->
                <a-select-option value="4">视频</a-select-option>
                <a-select-option value="2">图片</a-select-option>
                <a-select-option value="3">音频</a-select-option>
                <a-select-option value="0">文件夹</a-select-option>
                <a-select-option value="5">压缩文件</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :wrapperCol="{ span: 24 }">
              <a-col :span="24">
                <a-button type="primary" @click="getPageList(1)">查询</a-button>
                <a-button style="margin-left: 8px" @click=";(searchForm = {}), getPageList(1)">重置</a-button>
                <template v-if="detail.source != 1">
                  <a-button style="margin-left: 8px" @click="betchDown(true)">批量开启权限</a-button>
                  <a-button type="danger" style="margin-left: 8px" @click="betchDown(false)">批量关闭权限</a-button>
                </template>
              </a-col>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <a-row v-if="breadcrumbList.length > 1" style="margin-bottom: 10px">
        <a-breadcrumb>
          <a-breadcrumb-item v-for="(item, index) in breadcrumbList" :key="item.id">
            <span @click="handleBreadcrumb(index, item)" class="link"> {{ item.name }}</span>
          </a-breadcrumb-item>
        </a-breadcrumb>
      </a-row>
      <a-row type="flex">
        <!-- <a-col :span="3" style="min-width: 210px; width: 210px">
          <a-tree :selectedKeys.sync="searchForm.categoryId" :tree-data="folderList" :replace-fields="replaceFields" @select="selectFolder">
            <template slot="custom" slot-scope="data">
              <span>{{ data.name }}</span>
            </template>
          </a-tree>
          <div v-if="!folderList.length" class="empty">暂无数据</div>
        </a-col> -->
        <a-col :span="24" style="flex: 1">
          <a-table
            :row-selection="rowSelection"
            :columns="gradeColumns"
            :pagination="gradeTableRelevant.tablePagination"
            row-key="id"
            :loading="gradeTableRelevant.tableLoading"
            :data-source="gradeTableRelevant.tableDataSource"
          >
            <div slot="name" class="table-name" slot-scope="text">
              <img :src="$getFileType(text.fileType).icon" style="width: 15px; height: 15px" />
              <a @click="nextFolder(text, true)" v-if="!text.fileType">{{ text.name }} </a>
              <span v-else :title="text.name">{{ text.name + suffix(text.fileName, 1) }}</span>
            </div>
            <div slot="downloadAuthority" slot-scope="text">
              <span v-if="text.fileType == 0">--</span>
              <a-switch v-else :checked="text.isDownload" :disabled="!text.downloadAuthority || detail.source == 1" @change="changeDownload($event, [text.id], [text])"></a-switch>
            </div>
            <div slot="latestDownloadTime" slot-scope="text">
              <span>{{ text.latestDownloadTime || '--' }}</span>
            </div>
            <div slot="totalViews" slot-scope="text">
              <span>{{ text.totalViews }}</span>
            </div>
            <div slot="totalDownloads" slot-scope="text">
              <span>{{ text.totalDownloads }}</span>
            </div>
            <div slot="fileSize" slot-scope="text">
              {{
                text.fileSize > 1024 * 1024
                  ? (text.fileSize / (1024 * 1024)).toFixed(2) + 'M'
                  : text.fileSize / 1024 < 1
                  ? text.fileSize
                    ? text.fileSize + 'B'
                    : '--'
                  : (text.fileSize / 1024).toFixed(2) + 'KB'
              }}
            </div>
            <div slot="fileType" slot-scope="text">
              {{ searchFileType[text.fileType] }}
              {{ text.fileType === 1 && text.fileName ? `（${suffix(text.fileName)}）` : '' }}
            </div>
            <div slot="action" slot-scope="text">
              <a v-if="![5, 0].includes(text.fileType)" :class="text.fileType === 5 ? 'disabled-btn' : ''" style="margin-right: 10px" href="javaScript:;" @click="view(text)"> 查看</a>
            </div>
          </a-table>
        </a-col>
      </a-row>
    </a-card>
    <a-modal v-model="preview.visible" :centered="true" title="预览" width="800px" :footer="null" destroyOnClose>
      <a-spin :spinning="preview.loading">
        <div v-if="preview.info.fileType === 3" style="padding: 30px">
          <my-audio :src="preview.src | filterUrl"></my-audio>
        </div>
        <div id="J_prismPlayer" style="height: 500px" v-if="preview.info.fileType === 4"></div>
        <div v-if="preview.info.fileType === 2" style="height: 500px">
          <img :src="preview.src | filterUrl" alt="" style="width: 100%; height: 500px; object-fit: cover" />
        </div>
      </a-spin>
    </a-modal>
    <a-modal v-model="dirTypeView" :centered="true" title="选择批量操作类型" width="600px" destroyOnClose @ok="fileTypeOk" @cancel="cancelFiletype">
      <a-form :form="dirTypeForm" :labelCol="{ span: 4 }" :wrapperCol="{ span: 18 }">
        <a-row style="padding: 20px 0">
          <a-form-item label="文件类型">
            <a-select v-model="dirTypeForm.fileTypeList" mode="multiple" placeholder="请选择类型" style="width: 80%">
              <a-select-option value="1">文档</a-select-option>
              <!-- <a-select-option value="2">PPT</a-select-option> -->
              <a-select-option value="4">视频</a-select-option>
              <a-select-option value="2">图片</a-select-option>
              <a-select-option value="3">音频</a-select-option>
              <!-- <a-select-option value="0">文件夹</a-select-option> -->
              <a-select-option value="5">压缩文件</a-select-option>
            </a-select>
          </a-form-item>
        </a-row>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import MyAudio from '@/components/audio/index.vue'
import moment from 'moment'
import Api from '@/requests/apis'

export default {
  components: { MyAudio },
  data() {
    return {
      moment,
      dirTypeForm: {
        fileTypeList: [],
      },
      fileTypeList: [],
      dirTypeView: false,
      visible: false,
      detail: {},
      preview: {
        info: {},
      },
      moveVisible: false,
      movecategoryId: undefined,
      replaceFields: {
        key: 'id',
        title: 'name',
        children: 'children',
      },
      breadcrumbList: [
        {
          name: '教学资源',
          id: undefined,
        },
      ],
      searchFileType: ['文件夹', '文档 ', '图片', '音频', '视频', '压缩文件'],
      gradeTableRelevant: tableRelevant.call(this),
      gradeColumns: [
        {
          title: '资源标题',
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '源文件名称',
          dataIndex: 'sourceFileName',
        },
        {
          title: '大小',
          scopedSlots: { customRender: 'fileSize' },
        },
        {
          title: '类型',
          scopedSlots: { customRender: 'fileType' },
        },
        {
          title: '下载权限',
          scopedSlots: { customRender: 'downloadAuthority' },
        },
        {
          title: '下载次数',
          scopedSlots: { customRender: 'totalDownloads' },
        },
        {
          title: '查看次数',
          scopedSlots: { customRender: 'totalViews' },
        },
        {
          title: '最近下载时间',
          scopedSlots: { customRender: 'latestDownloadTime' },
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' },
        },
      ],
      selectedRowKeys: [],
      selectRow: [],
      searchForm: {},
      dirForm: this.$form.createForm(this, { name: 'coordinated' }),
      confirmLoading: false,
      folderList: [],
    }
  },
  created() {
    this.$store.commit('setting/setShowPageTitle', false)
    if (this.$route.query.id) {
      const params = JSON.parse(this.$route.query.params)
      this.detail = params
      // this.detail.source==1?this.detail.superiorResourcePackageId:
      this.getDetail(this.$route.query.id)
      this.getResourDetail(params.resourcePackageId)
      this.getTreeMenu()
    }
  },
  beforeDestroy() {
    this.$store.commit('setting/setShowPageTitle', true)
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        getCheckboxProps: (record) => ({
          props: {
            disabled: ((!record.downloadAuthority&&record.fileType !== 0 )|| this.detail.source == 1)
          },
        }),
        onSelect: (record, selected) => {
          if (record.fileType === 0 && selected) {
            this._recordDir = record
            this.dirTypeView = true
          }
          if (selected) {
            this.selectedRowKeys.push(record.id)
            this.selectRow.push(record)
          } else {
            this.selectedRowKeys = this.selectedRowKeys.filter((v) => v != record.id)
            this.selectRow = this.selectRow.filter((v) => v.id != record.id)
            if (!this.selectRow.some((v) => v.fileType === 0)) {
              this.fileTypeList = []
            }
          }
        },
        onSelectAll: (selected, selectedRows, changeRow) => {
          const ids = changeRow.map((v) => v.id)
          const fl = changeRow.filter((v) => v.fileType === 0)
          if (fl.length && selected) {
            this._recordDir = fl
            this.dirTypeView = true
          }
          if (selected) {
            this.selectedRowKeys.push(...ids)
            this.selectRow.push(...changeRow)
          } else {
            this.selectedRowKeys = this.selectedRowKeys.filter((v) => !(ids.indexOf(v) != -1))
            this.selectRow = this.selectRow.filter((v) => !(ids.indexOf(v.id) != -1))
            this.fileTypeList = []
          }
        },
      }
    },
  },
  methods: {
    cancelFiletype() {
      const dirIds = []
      if (Array.isArray(this._recordDir)) {
        dirIds.push(...this._recordDir.map((v) => v.id))
      } else {
        dirIds.push(this._recordDir.id)
      }
      this.selectedRowKeys = this.selectedRowKeys.filter((v) => !dirIds.includes(v))
      this.selectRow = this.selectRow.filter((v) => !dirIds.includes(v.id))
      this.dirTypeForm.fileTypeList = []
      this.dirTypeView = false
      this._recordDir = null
    },
    fileTypeOk() {
      if (this.dirTypeForm.fileTypeList.length == 0) {
        return this.$message.warning('请选择文件类型')
      }
      this.fileTypeList = [...new Set([...this.dirTypeForm.fileTypeList, ...this.fileTypeList])]
      this.dirTypeForm.fileTypeList = []
      this.dirTypeView = false
      this._recordDir = null
      // this.dirForm.validateFields((err, values) => {
      //   if (!err) {
      //     this.fileTypeList.push(...this.dirTypeForm.fileTypeList)
      //     this.cancelFiletype()
      //   }
      // })
    },
    getByFold(id) {
      const stack = [...this.folderList]
      while (stack.length) {
        const item = stack.pop()
        if (item.id == id) {
          return item
        }
        if (item.children) {
          item.children.forEach((v) => stack.push(v))
        }
      }
    },
    selectFolder(e = []) {
      if (!e[0] || e[0] < 0) {
        this.breadcrumbList = this.breadcrumbList.slice(0, 1)
        this.getPageList(1)
      } else {
        const item = this.getByFold(e[0])
        if (item) {
          this.breadcrumbList = this.breadcrumbList.slice(0, 1)
          if (item.parentId) {
            const item2 = this.folderList.find((v) => v.fileResourceId == item.parentId)
            if (item2) {
              this.nextFolder(item2)
            }
          }
          this.nextFolder(item, true)
        } else {
          this.getPageList(1)
        }
      }
    },
    getTreeMenu() {
      function initTree(data = []) {
        return data.map((v) => {
          v.scopedSlots = { title: 'custom' }
          if (v.children) {
            v.children = initTree(v.children)
          }
          return v
        })
      }
      this.$http.CourseResource.getTreeMenu({ id: this.detail.resourcePackageId }).then((data) => {
          this.folderList = data.data.filter((v) => v.id !== -1)
          this.folderList.unshift({
            name: '全部',
            id: -2,
            children: [],
          })
          this.folderList = initTree(this.folderList)
      })
    },
    getDetail(id) {
      this.$http.CourseService.getResourseById(id).then((res) => {
        const { data = {} } = res
        delete data.remark
        delete data.description
        this.detail = { ...this.detail, ...data }
        this.getPageList(1)
      })
    },
    getResourDetail(id) {
      this.$http.CourseResource.ResourcePackageGet(id).then((res) => {
        const { data = {} } = res
        this.detail.size = data.size
        this.detail.count = data.count
        this.detail.remark = data.remark
        this.detail.description = data.description
      })
    },
    getDownloadStatus(ids) {
      if (!ids.length) return
      const params = {
        resourceIds: [],
      }
      ids.forEach((v) => {
        params.resourceIds.push(v)
      })
      // if (this.detail.source == 1) {
      //   params.organizationResourcePackageId = this.detail.superiorResourcePackageId
      // } else {
      //   params.organizationResourcePackageId = this.detail.id
      // }
      params.organizationResourcePackageId = this.detail.id
      this.$http.CourseService.getResourseListUsage(params).then((res) => {
        const { data } = res
        for (let i = 0; i < this.gradeTableRelevant.tableDataSource.length; i++) {
          const item = this.gradeTableRelevant.tableDataSource[i]
          const isitem = data.find((v) => {
            if (v.resourceId == item.id) {
              item.totalDownloads = v.totalDownloads
              item.totalViews = v.totalViews
              item.latestDownloadTime = v.latestDownloadTime
              if (v.isDownloadable && item.downloadAuthority) {
                item.isDownload = true
                this.$set(item, 'isDownload', true)
                return true
              } else {
                this.$set(item, 'isDownload', false)
              }
            }
          })
        }
        this.gradeTableRelevant.tableDataSource = [...this.gradeTableRelevant.tableDataSource]
      })
    },
    changeDownload(e, reocrdIds, reocrd, betch = false) {
      const params = {
        resourceIds: [],
        fileTypeList: [],
      }
      params.organizationResourcePackageId = this.detail.id
      reocrdIds.forEach((id) => {
        params.resourceIds.push(id)
      })
      params.isDownloadable = e
      if (betch) {
        ;[...new Set([...this.selectRow.map((v) => +v.fileType), ...this.fileTypeList.map((v) => +v)])].forEach((type) => {
          params.fileTypeList.push(type)
        })
      } else {
        params.fileTypeList.push(reocrd[0].fileType)
      }

      this.$http.CourseService.resourseUpdateDown(params).then((res) => {
        const { data } = res
        this.$message.success('操作成功')
        reocrd.forEach((v) => {
          this.$set(v, 'isDownload', e)
        })
        this.getDownloadStatus(reocrdIds)
        if (betch) {
          this.selectedRowKeys = []
          this.selectRow = []
          this.fileTypeList = []
        }
      })
    },
    betchDown(e) {
      if (!this.selectedRowKeys.length) {
        return this.$message.warning('请至少选择一项资源')
      }
      this.changeDownload(e, this.selectedRowKeys, this.selectRow, true)
    },
    nextFolder(record, flag) {
      this.breadcrumbList.push({
        id: record.id,
        name: record.name,
        categoryId: record.categoryId,
        folderType: record.folderType,
      })
      this.searchForm.name = undefined
      this.searchForm.fileType = undefined
      this.searchForm = { ...this.searchForm }
      flag && this.getPageList(1)
    },
    handleBreadcrumb(index, item) {
      this.breadcrumbList = this.breadcrumbList.slice(0, index + 1)
      if (this.breadcrumbList.length === 1) {
        this.searchForm.categoryId = []
      }
      this.getPageList(1)
    },
    addRource() {
      const query = {}
      if (this.$route.query.id) {
        query.id = this.$route.query.id
        query.params = JSON.stringify(this.detail)
      }
      this.$router.push({ path: '/content/addTResources', query })
    },
    getPageList(pageIndex) {
      const params = {
        pageIndex: pageIndex || this.gradeTableRelevant.tablePagination.current,
        pageSize: this.gradeTableRelevant.tablePagination.pageSize,
        ...this.searchForm,
        resourcePackageId: this.detail.resourcePackageId,
      }
      if (params.name || params.fileType !== undefined) {
        this.breadcrumbList = this.breadcrumbList.slice(0, 1)
        this.searchForm.categoryId = []
      }
      if (this.breadcrumbList.length > 1) {
        const item = this.breadcrumbList.slice(-1)[0]
        params.categoryId = item.id
        this.searchForm.categoryId = [item.id]
        // params.folderType = item.folderType
      } else {
        params.categoryId = (this.searchForm.categoryId || [])[0]
      }

      if (params.categoryId < 0) {
        params.categoryId = undefined
      }

      this.gradeTableRelevant.tableLoading = true
      this.$http.CourseResource.getPagelistPackage(params).then((data) => {
        this.gradeTableRelevant.tableLoading = false
          this.gradeTableRelevant.tableDataSource = data.data.items.map((item) => {
            item.totalDownloads = 0
            item.totalViews = 0
            item.size = item.fileSize
            return item
          })
          this.gradeTableRelevant.tablePagination.total = data.data.totalCount
          this.gradeTableRelevant.tablePagination.current = data.data.pageIndex
          this.getDownloadStatus(this.gradeTableRelevant.tableDataSource.map((v) => v.id))
      })
    },
    suffix(str, point) {
      str = str || ''
      if (point) {
        return str.substring(str.lastIndexOf('.')).toLowerCase()
      }
      return str.substring(str.lastIndexOf('.') + 1).toLowerCase()
    },
    view(val) {
      this.$message.destroy()
      if (val.fileType === 5) {
        this.$message.error('文件不支持预览')
        return
      }
      if (!val.fileType) {
        this.nextFolder(val, true)
        return
      }
      this.preview = {
        visible: true,
        loading: false,
        info: val,
        src: process.env.VUE_APP_API_BASE_URL + Api.Content.downloadFileStream +'?id=' + val.fileResourceId,
      }
      if (val.fileType === 4) {
        const params = { id: val.fileResourceId }
        this.$http.FileResource.getVideoPlayAuth(params).then((res) => {
          const { data } = res
          this.$nextTick(() => {
            new Aliplayer(
              {
                id: 'J_prismPlayer',
                width: '100%',
                height: '500px',
                autoplay: true,
                vid: data.videoId, //播放方式二必选参数。可以通过点播控制台（媒资库>音/视频路径）查询。示例：1e067a2831b641db90d570b6480f****。
                playauth: data.playAuth, //播放方式二必选参数。参数值可通过调用GetVideoPlayAuth接口获取。
              },
              (player) => {
                console.log('The player is created.')
              }
            )
          })
        }).catch(e => {
          this.preview.visible = false
        })
      }
      if (val.fileType === 2) {
        this.preview.loading = true
        const xhr = new XMLHttpRequest()
        xhr.open('GET', this.preview.src, true)
        xhr.responseType = 'blob'
        xhr.setRequestHeader('Authorization', 'Bearer ' + this.$store.getters['account/token']())
        xhr.send(null)
        xhr.onload = () => {
          this.preview.src = window.URL.createObjectURL(xhr.response)
          this.preview.loading = false
        }
      }
      if (val.fileType === 1) {
        this.preview.visible = false
        const Params = {
          materialId: val.fileResourceId,
        }
        this.$http.resourcesList.GeneratePresignedUri(Params).then((res) => {
          const { data } = res
          window.open(data)
        })
      }
    },
  },
}
</script>
<style lang="less" scoped>
.header {
  background: #fff;
  width: calc(100% + 48px);
  margin-top: -24px;
  margin-left: -24px;
  margin-bottom: 24px;
  padding: 0 24px;
  padding-bottom: 20px;
  h1 {
    font-weight: 500;
    font-size: 20px;
  }
  .header-content {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    color: #333;
    .left {
      font-size: 16px;
      // font-weight: 600;
      .item-box {
        display: flex;
        .item {
          width: 300px;
          word-break: break-all;
          white-space: break-spaces;
        }
      }
    }
  }
}
.table-name {
  display: flex;
  align-items: center;
  img {
    margin-right: 4px;
  }
}
.empty {
  color: #666;
  text-align: center;
}
.link {
  cursor: pointer;
}
</style>
